import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./assets/scss/style.scss"
import "bootstrap/dist/js/bootstrap.bundle"
import App from "./App";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider";
import ErrorBoundary from "./context/ErrorBoundary";
import { DialogContextProvider } from "./context/DialogContext";
import { IdleTimeoutProvider } from "./components/IdleTimeout/IdleTimeoutProvider";
import { ExtractionProvider } from "./context/ExtractionContext";
import { primeBatchReviewLoad } from "./helper/batchReviewPrefetch";

// Issue the Batch Review request BEFORE React renders. The auth bootstrap and the feature-flag
// fetch each gate the route behind a full round-trip, and neither changes what this request asks
// for -- so waiting for them costs ~1.1s of dead time on the one screen whose data is expensive.
// No-ops for every other route and for any URL that promises a narrower scope.
primeBatchReviewLoad();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <AuthProvider>
      <IdleTimeoutProvider>
        <DialogContextProvider>
          <ExtractionProvider>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </ExtractionProvider>
        </DialogContextProvider>
      </IdleTimeoutProvider>
    </AuthProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
